export default __webpack_public_path__ + "static/media/steps.a3da7e65.svg";